import React, { useState } from 'react';
import HeaderLayout from '../layouts/Header';
import FooterLayout from '../layouts/Footer';
import FooterWithCopyright from '../layouts/FooterWithCopyright';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./Main.css";

import LoginModal from '../modals/LoginModal';

const LearnPage = () => {

    const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
    const showLoginModal = () => setIsLoginModalVisible(true);
    const cancelLoginModal = () => setIsLoginModalVisible(false);

    return (
        <div className="background-element">
            <HeaderLayout onLoginClick={showLoginModal}/>

            <div className="page-content-container">
                <h1 className="page-title">มาเรียนรู้ศาสตร์แห่งตัวเลขกับเรา</h1>
                <img src="/book_cover.jpg" className="book-image"></img>
                <h2 className="page-title">ด้วยเนื้อหาสุดเข้มข้นกับอาจารย์นัท</h2>
                <h2 className="page-title-description">ติดตามได้ที่</h2>

                <a href="https://www.facebook.com/LightofSoul567" style={{display:"flex", justifyContent: "center", alignItems:"center"}}>
                    <img src="/facebook.png" className="facebook-image"/>
                </a>

                <img src="/line-official.png"style={{width: "60%", maxWidth:"200px", borderRadius: "10px", marginTop: "20px"}}/>

            </div>

            <FooterLayout onLoginClick={showLoginModal}/>
            <FooterWithCopyright/>

            <LoginModal visible={isLoginModalVisible} onClose={cancelLoginModal} />
        </div>
    
    );
};

export default LearnPage;